import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: 0,
		width: 40,
		height: 40,
		rx: 20,
		fill: "black",
		fillOpacity: .75
	}), /* @__PURE__ */ _jsx("path", {
		d: "M28 20.625L16 27.5532L16 12.6968L28 20.625Z",
		fill: "currentColor"
	})]
});
export default SvgPlayButton;
